import commonservice from "@apis/commonservice";
import { useLoginHistory } from "@pages/home/login/hooks";
import report from "@report";
import { useState } from "react";
import useUserInfo from "./userInfo";
import { useAppSelector } from "./redux";
import { LOCALSTORAGE_KEY } from "@config";

export const useLogout = () => {
  const [loading, setLoading] = useState(false);
  const { updateListInfo } = useLoginHistory();
  const { userInfo } = useUserInfo();
  const { region, membership } = useAppSelector((state) => state.globalReducer);
  const logout = () => {
    setLoading(true);
    report.click({ kalo_pos: "logout" });
    commonservice.logout().then(() => {
      updateListInfo(userInfo.uid, {
        logoutTime: Date.now(),
        lastCountry: region,
        expired: membership?.expired,
        level: membership?.level,
      });
      localStorage.removeItem(LOCALSTORAGE_KEY.ACCESS_TOKEN);

      setLoading(false);
      location.href = "/login";
    });
  };

  return { logout, loading };
};
